import { api, apiEnvelope, type PaginationMeta } from './api';

export interface DiscoveredRoom {
  id: string;
  external_id: string;
  calendar_id: string;
  name: string;
  room_list: string | null;
  building: string | null;
  floor: string | null;
  capacity: number | null;
  features: string[];
  address: string | null;
  is_active: boolean;
  last_seen_at: string | null;
  mapped_to_space_id: string | null;
  mapped_to_space_name: string | null;
}

export interface RoomFilters {
  buildings: string[];
  floors: string[];
  room_lists: string[];
}

export interface RoomQuery {
  building?: string;
  floor?: string;
  search?: string;
  unmappedOnly?: boolean;
  includeInactive?: boolean;
  page?: number;
  limit?: number;
}

function toQueryString(query: RoomQuery): string {
  const params = new URLSearchParams();
  if (query.building) params.set('building', query.building);
  if (query.floor) params.set('floor', query.floor);
  if (query.search) params.set('search', query.search);
  if (query.unmappedOnly) params.set('unmapped_only', 'true');
  if (query.includeInactive) params.set('include_inactive', 'true');
  params.set('page', String(query.page ?? 1));
  params.set('limit', String(query.limit ?? 100));
  return params.toString();
}

export const roomsApi = {
  list: (query: RoomQuery = {}) =>
    apiEnvelope<DiscoveredRoom[]>(`/calendar/rooms?${toQueryString(query)}`) as Promise<{
      data: DiscoveredRoom[];
      meta?: PaginationMeta;
    }>,

  filters: () => api<RoomFilters>('/calendar/rooms/filters'),

  rediscover: (connectionId: string) =>
    api<{ discovered: number; added: number; deactivated: number }>(
      `/calendar/connections/${connectionId}/rediscover`,
      { method: 'POST' },
    ),
};
